module.exports = __webpack_public_path__ + "static/media/pii_icon.bae17457.png";